import { Injectable } from '@angular/core';
import { Api } from '../services/api';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(public api: Api) {
  }


  getUserContent() {
    let seq = this.api.get('login/v1/getUserContext');
    return seq;
  }

}
